import DividerText from './component'
export { DividerText }
export default DividerText